'use client'

import {Icon} from '@iconify/react'
import Image from 'next/image'
import {Turnstile} from 'next-turnstile'
import Link from 'next/link'
import {useState} from "react";

export default function ContactUs() {
    const [verified, setVerified] = useState(false)

    const submitForm = async (values) => {
        const url = "https://script.google.com/macros/s/AKfycbzAjMBalkYZ_4fHmJ17fy_ZnXGkC3tGY5F4DMymONLd7y4DEBOPAF-k4hyJnEhKXIq2/exec"

        await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
        })
    }

    return (
        <div className='container max-w-8xl mx-auto px-5 2xl:px-0 pt-32 md:pt-44 pb-14 md:pb-28'>
            <div className='mb-16'>
                <div className='flex gap-2.5 items-center justify-center mb-3'>
          <span>
            <Icon
                icon={'streamline-sharp:cog-solid'}
                width={20}
                height={20}
                className='text-primary'
            />
          </span>
                    <p className='text-base font-semibold text-badge dark:text-white/90'>
                        Bize Ulaşın
                    </p>
                </div>
                <div className='text-center'>
                    <h3 className='text-4xl sm:text-52 font-medium tracking-tighter text-black dark:text-white mb-3 leading-10 sm:leading-14'>
                        Sorularınız mı var? Yardım etmeye hazırız!
                    </h3>
                </div>
            </div>
            {/* form */}
            <div className='border border-black/10 dark:border-white/10 rounded-2xl p-4 shadow-xl dark:shadow-white/10'>
                <div className='flex flex-col lg:flex-row lg:items-center gap-12'>
                    <div className='relative w-fit'>
                        <Image
                            src={'/images/contactUs/contactUs.png'}
                            alt='wall'
                            width={497}
                            height={535}
                            className='rounded-2xl brightness-50 h-full'
                            unoptimized={true}
                        />
                        <div className='absolute top-6 left-6 lg:top-12 lg:left-12 flex flex-col gap-2'>
                            <h5 className='text-xl xs:text-2xl mobile:text-3xl font-medium tracking-tight text-white'>
                                Bilgilerimiz
                            </h5>
                        </div>
                        <div
                            className='absolute bottom-6 left-6 lg:bottom-12 lg:left-12 flex flex-col gap-4 text-white'>
                            <Link href={'/'} className='w-fit'>
                                <div className='flex items-center gap-4 group w-fit'>
                                    <Icon icon={'ph:phone'} width={32} height={32}/>
                                    <p className='text-sm xs:text-base mobile:text-xm font-normal group-hover:text-primary'>
                                        +90 (537) 415 15 72
                                    </p>
                                </div>
                            </Link>
                            <Link href={'/'} className='w-fit'>
                                <div className='flex items-center gap-4 group w-fit'>
                                    <Icon icon={'ph:envelope-simple'} width={32} height={32}/>
                                    <p className='text-sm xs:text-base mobile:text-xm font-normal group-hover:text-primary'>
                                        info@trafirap.com
                                    </p>
                                </div>
                            </Link>
                            <Link href={"https://maps.app.goo.gl/XNcChXQhMUrqUM4q8"}>
                                <div className='flex items-center gap-4'>
                                    <Icon icon={'ph:map-pin'} width={32} height={32}/>
                                    <p className='text-sm xs:text-base mobile:text-xm font-normal'>
                                        Batı Sitesi, Batı Bulvarı No:129 06370 Yenimahalle, Ankara
                                    </p>
                                </div>
                            </Link>
                            <Link href={"https://maps.app.goo.gl/FWoNbuNEm19DYRFD6"}>
                                <div className='flex items-center gap-4'>
                                    <Icon icon={'ph:map-pin'} width={32} height={32}/>
                                    <p className='text-sm xs:text-base mobile:text-xm font-normal'>
                                        Altunizade Mah. B. Saadettin Kaynak Sok. <br/>
                                        No:10/1 Üsküdar, İstanbul
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className='flex-1/2'>
                        <form action="https://submit-form.com/sowhRfCd3">
                            <div className='flex flex-col gap-8'>
                                <div className='flex flex-col lg:flex-row gap-6'>
                                    <input
                                        type='text'
                                        name='username'
                                        id='username'
                                        autoComplete='username'
                                        placeholder='İsminiz*'
                                        required
                                        className='px-6 py-3.5 border border-black/10 dark:border-white/10 rounded-full outline-primary focus:outline w-full'
                                    />
                                    <input
                                        type='number'
                                        name='mobile'
                                        id='mobile'
                                        autoComplete='mobile'
                                        placeholder='Telefon Numaranız*'
                                        required
                                        className='px-6 py-3.5 border border-black/10 dark:border-white/10 rounded-full outline-primary focus:outline w-full'
                                    />
                                </div>
                                <input
                                    type='email'
                                    name='email'
                                    id='email'
                                    autoComplete='email'
                                    placeholder='E-Posta*'
                                    required
                                    className='px-6 py-3.5 border border-black/10 dark:border-white/10 rounded-full outline-primary focus:outline'
                                />
                                <textarea
                                    rows={8}
                                    cols={50}
                                    name='message'
                                    id='message'
                                    placeholder='Mesajınızı yazın...'
                                    required
                                    className='px-6 py-3.5 border border-black/10 dark:border-white/10 rounded-2xl outline-primary focus:outline'></textarea>
                                <Turnstile
                                    siteKey="0x4AAAAAABmCTdMi-vIpVJXT"
                                    retry="auto"
                                    refreshExpired="auto"
                                    onVerify={() => setVerified(true)}
                                />
                                <button
                                    disabled={!verified}
                                    className='px-8 py-4 rounded-full bg-primary text-white text-base font-semibold w-full mobile:w-fit hover:cursor-pointer hover:bg-dark duration-300'>
                                    Gönder
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
